function handleError(error) {
    // eslint-disable-next-line
    console.log(error);
}

export { handleError };
